// extracted by mini-css-extract-plugin
export default {"skeleton":"styles-module__skeleton___Yv3LD"};